import { render, staticRenderFns } from "./Plants.vue?vue&type=template&id=2d7632c1&scoped=true&"
import script from "./Plants.vue?vue&type=script&lang=js&"
export * from "./Plants.vue?vue&type=script&lang=js&"
import style0 from "./Plants.vue?vue&type=style&index=0&id=2d7632c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7632c1",
  null
  
)

export default component.exports